import { useSearchParams } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Card } from '../ui/Card';
import { LinkButton } from '../ui/LinkButton';

export default function SlackInstalled() {
  const [searchParams] = useSearchParams();
  const teamName = searchParams.get('team');

  return (
    <Card>
      <h1 className="font-display text-3xl font-semibold tracking-tight text-text sm:text-[2rem]">
        Send a Secret is installed{teamName ? ` in ${teamName}` : ''}
      </h1>
      <p className="mt-3 text-sm text-text-muted sm:text-base">
        Run the slash command in any channel to create a one-time link:
      </p>
      <div className="mt-4 rounded-lg border border-border bg-bg px-4 py-3 font-mono text-sm text-text">
        /secret your message here
      </div>
      <p className="mt-4 text-sm text-text-muted sm:text-base">
        The bot replies privately with a link that burns on the first view. Paste it wherever
        you want to share it &mdash; the recipient sees the secret once, then it&rsquo;s gone.
      </p>
      <div className="mt-6">
        <LinkButton to="/" variant="secondary" fullWidth leadingIcon={<Sparkles size={18} />}>
          Try the web form too
        </LinkButton>
      </div>
    </Card>
  );
}
